import { css, type Theme } from "@emotion/react";

import { dimensions } from "@styles";

const promoGradientStartPercent = 25.416;

export const footerBase = css`
  position: relative;
`;

export const inverseSubtleText = css`
  opacity: 0.6;
`;

export const fullBleedBreakout = css`
  margin-inline: calc(50% - 50vw);
  padding-inline: calc(50vw - 50%);
`;

export const promoFullBleedSection = (theme: Theme) => css`
  ${fullBleedBreakout}
  --band-gradient-angle: -75.61deg;
  background: linear-gradient(
    var(--band-gradient-angle),
    ${theme.ds5.asset.grey[900]} ${promoGradientStartPercent}%, ${theme.ds5.asset.grey[800]}
      ${100 - promoGradientStartPercent}%
  );
  border-radius: ${theme.ds5.radius.background.xlarge} ${theme.ds5.radius.background.xlarge} 0 0;

  @media (min-width: ${dimensions.tablet}) {
    --band-gradient-angle: -46.41deg;
  }
`;

export const inverseFullBleedSection = (theme: Theme) => css`
  ${fullBleedBreakout}
  background: ${theme.ds5.inverse.backgroundBold};
  padding-block: ${theme.ds5.padding.static[600]};
`;

export const fdaDisclaimer = css`
  @media (min-width: ${dimensions.desktop}) {
    max-width: 700px;
  }
`;

export const mobileLayout = css`
  text-align: center;
`;

export const inverseBottomBarDivider = (theme: Theme) => css`
  border-color: ${theme.ds5.inverse.borderBold};
  margin-block: ${theme.ds5.spacing.gap.medium};
`;
